<!-- 画笔的动画 -->
<template>
  <div class="sprite-animation-container">
    <div class="sprite-animation-item">
      <div class="sprite-animation-label">动画效果</div>
      <div>
        <el-select
          v-model="chooseAnimate"
          size="mini"
          placeholder="请选择"
          value-key="name"
        >
          <el-option
            v-for="selectitem in AnimationList"
            :key="selectitem.type"
            :label="selectitem.name"
            :value="selectitem"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div
      class="sprite-animation-item"
      v-if="chooseAnimate && chooseAnimate.type == AnimationType.custom"
    >
      <div class="sprite-animation-label">自定义动画帧</div>
      <div>
        <el-button size="mini" @click="animationDialogVisible = true"
          >...</el-button
        >
      </div>
    </div>
    <div class="sprite-animation-item">
      <div class="sprite-animation-label">动画时长(毫秒)</div>
      <div>
        <el-input-number
          v-model="duration"
          controls-position="right"
          size="mini"
          :step="500"
        ></el-input-number>
      </div>
    </div>
    <div class="sprite-animation-item">
      <div class="sprite-animation-label">循环次数</div>
      <div>
        <el-input-number
          v-model="cycle"
          controls-position="right"
          size="mini"
          :step="1"
          placeholder="默认无限循环"
        ></el-input-number>
      </div>
    </div>

    <div class="sprite-animation-item">
      <div class="sprite-animation-label">下一个动画</div>
      <div>
        <el-input
          v-model="nextAnimate"
          placeholder="下一个动画的tag标签"
          size="mini"
        ></el-input>
      </div>
    </div>

    <div class="sprite-animation-item">
      <div class="sprite-animation-label">自动播放</div>
      <div>
        <el-switch
          v-model="autoPlay"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>
    </div>

    <div class="sprite-animation-item">
      <div class="sprite-animation-label">保持最后状态</div>
      <div>
        <el-switch
          v-model="lastState"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </div>
    </div>

    <div class="animate-menus">
      <el-button
        type="primary"
        icon="el-icon-video-play"
        @click="changeState('play')"
        >播放</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-video-pause"
        @click="changeState('pause')"
        >暂停</el-button
      >
      <el-button
        type="primary"
        icon="el-icon-circle-close"
        @click="changeState('stop')"
        >停止</el-button
      >
    </div>

    <el-dialog
      title="自定义动画帧"
      :visible.sync="animationDialogVisible"
      width="50%"
      :modal="false"
    >
      <div>
        <el-button size="mini" @click="addFrame" type="primary"
          >添加动画帧</el-button
        >

        <el-collapse class="frame-content">
          <el-collapse-item
            :title="'第' + (index + 1) + '帧'"
            v-for="(item, index) in customFrameList"
          >
            <div class="scroll-view">
              <div>
                <el-button size="mini" @click="addAnimateProp(item)" type="info"
                  >添加动画属性</el-button
                >
                <el-button size="mini" @click="removeFrame(index)"
                  >删除当前帧</el-button
                >
                <div
                  class="sprite-animation-item"
                  v-if="item[0]"
                  style="margin-top: 15px"
                >
                  <div class="sprite-animation-label">动画时长(毫秒)</div>
                  <div>
                    <el-input-number
                      v-model="item[0].duration"
                      controls-position="right"
                      :min="1"
                      size="mini"
                      :step="100"
                    >
                    </el-input-number>
                  </div>
                </div>
                <div class="animate-list">
                  <div
                    class="animate-prop-item"
                    v-for="(item2, index2) in item"
                  >
                    <div class="prop-info">
                      <div class="text-item">
                        <span>属性名</span>

                        <el-autocomplete
                          class="input-text"
                          v-model="item2.key"
                          :fetch-suggestions="querySearch"
                          placeholder="请输入内容"
                          size="mini"
                          @select="handleSelect($event,item2)"
                        >
                          <template slot-scope="{ item }">
                            <div class="name">{{ item }}</div>
                          </template>
                        </el-autocomplete>

                        <!-- <input
                          type="text"
                          class="input-text"
                          v-model="item2.key"
                        /> -->
                      </div>
                      <div class="text-item">
                        <span>属性值</span>
                        <!-- <input
                          type="text"
                          class="input-text"
                          v-model="item2.val"
                        /> -->
                        <el-input
                        size="mini"
                          class="input-text"
                          v-model="item2.val"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                    <el-button size="mini" @click="removeProps(item, index2)"
                      >删除</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="animationDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFrame">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import AnimationList from "../../types/sprite-animation.js";
import { AnimationType } from "../../types/sprite-types";
export default {
  data() {
    return {
      AnimationList,
      AnimationType,
      restaurants: ["width","height","x","y","visible","text","textColor","fontSize","showChild","rotate","background","color","scale"],
      chooseAnimate: null, //选择动画类型
      duration: 400, //动画时长
      cycle: Infinity, //循环次数
      nextAnimate: "", //下一个动画的tag
      autoPlay: false, //是否自动播放动画
      lastState: false, //是否保持动画播放完成后的状态
      animationDialogVisible: false,
      customFrameList: [],
    };
  },
  created() {
    this.topo = this.$Core.getProvider("TechnologyTopo");
    this.init();
  },
  destroyed() {
    this.saveConfig();
  },

  methods: {
    handleSelect(event,item){
      
      item.key = event
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // 保存动画帧
    saveFrame() {
      let frames = [];
      this.customFrameList.forEach((item) => {
        let frame = {};
        item.forEach((prop) => {
          frame[prop.key] = prop.val;
          if (prop.duration) {
            frame["duration"] = prop.duration;
          }
        });
        frames.push(frame);
      });
      console.log(frames);
      this.chooseAnimate.frames = frames;
      this.animationDialogVisible = false;
    },
    removeFrame(index) {
      this.customFrameList.splice(index, 1);
    },
    // 删除添加属性
    removeProps(propArr, index) {
      propArr.splice(index, 1);
    },
    // 添加动画属性
    addAnimateProp(frame) {
      let obj = {
        key: "",
        val: "",
      };
      // 设置默认动画时长
      if (frame.length == 0) {
        obj.duration = 400;
      }

      frame.push(obj);
    },
    // 添加动画帧
    addFrame() {
      this.customFrameList.push([]);
    },
    // 初始化 参数
    init() {
      this.spriteFremas = this.topo.data.spriteFremas;

      if (this.topo.store && this.topo.store.active.length == 1) {
        this.active = this.topo.store.active[0];
      }

      if (!this.active) return;

      let animateType = this.active.$animateType;

      this.chooseAnimate = AnimationList.find(
        (item) => item.type == animateType
      );

      // 自定义动画帧数据格式化
      if (animateType == AnimationType.custom) {
        this.active.frames.forEach((frameObj) => {
          console.log(frameObj);
          let frames = [];
          Object.keys(frameObj).forEach((key) => {
            if (key == "duration") {
              return;
            }
            let obj = {
              key: key,
              val: frameObj[key],
            };
            frames.push(obj);
            console.log(frames);
          });
          frames[0].duration = frameObj.duration;
          this.customFrameList.push(frames);
        });
        console.log(this.customFrameList);
      }

      // 初始化参数
      this.duration = this.active.duration || 400;
      this.cycle = this.active.animateCycle || Infinity;
      this.nextAnimate = this.active.nextAnimate || "";

      this.autoPlay = this.active.autoPlay || false;
      this.lastState = this.active.keepAnimateState || false;
    },
    // 保存已经编辑的配置
    saveConfig() {
      if (!this.active || !this.chooseAnimate) return;
      this.active.duration = this.duration;
      this.active.animateCycle = this.cycle;
      this.active.nextAnimate = this.nextAnimate;

      this.active.autoPlay = this.autoPlay;
      this.active.keepAnimateState = this.lastState;

      if (!this.active.frames) {
        this.active.frames = [];
      }

      let valData = {
        id: this.active.id,
        duration: this.active.duration,
        animateCycle: this.active.animateCycle,
        nextAnimate: this.active.nextAnimate,
        autoPlay: this.active.autoPlay,
        keepAnimateState: this.active.keepAnimateState,
        frames: this.active.frames,
      };

      if (this.chooseAnimate) {
        //   选择的动画
        valData.$animateType = this.active.$animateType =
          this.chooseAnimate.type;
        valData.frames = this.active.frames = this.chooseAnimate.frames;
      }
      this.topo.stageCanvas.setValue(valData);
    },
    changeState(state) {
      if (!this.active) return;
      switch (state) {
        case "play":
          // 播放
          this.saveConfig();
          this.topo.stageCanvas.startAnimate(this.active.id);
          break;
        case "pause":
          this.topo.stageCanvas.pauseAnimate(this.active.id);
          break;
        case "stop":
          this.topo.stageCanvas.stopAnimate(this.active.id);
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.sprite-animation-container {
  .sprite-animation-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .sprite-animation-label {
      width: 120px;
    }
  }
  .animate-menus {
    display: flex;
    margin-top: 30px;
  }
}
.frame-content {
  margin-top: 15px;
  .animate-list {
    margin-top: 15px;
    .animate-prop-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 0;
      &:hover {
        background: rgba($color: #000000, $alpha: 0.1);
        border-radius: 5px;
      }
    }
    .prop-info {
      display: flex;
      .input-text {
        width: 100px;
      }
      .text-item {
        margin-left: 15px;
      }
    }
  }
  .scroll-view {
    max-height: 500px;
    overflow-y: auto;
  }
}
</style>